import { getField, updateField } from 'vuex-map-fields';

import {
  createJKOPayOrder,
} from '@/api/JKOPay';

import JKOPayResponseCodesTable from '@/enums/JKOPay.js';

export default {
  namespaced: true,

  state: {
    platformOrderId: '', // 捐款ID (saleforce 提供)
  },

  mutations: {
    updateField,

    updatePlatformOrderId(state, oppoId) {
      state.platformOrderId = oppoId;
    },

  },

  getters: {

    getField,

    donateResultInfo(state, getters, rootState) {
      // 因為最後一頁是從街口回來，所以不會有捐款 ID 相關資訊
      const fields = [];

      fields.push({
        name: '付款方式',
        value: '街口支付',
      });

      fields.push({
        name: '捐款編號',
        value: state.platformOrderId,
      });

      fields.push({
        name: '捐款金額',
        value: rootState.donation.amount,
      });

      fields.push({
        name: '捐款結果',
        value: '捐款成功', // 會跳到結果頁面，一定是捐款成功
      });

      return fields;
    },
  },

  actions: {
    // 產出 JKOPAY 付款連結
    async createJKOPayPaymentURL({ state, rootState }) {

      const payload = {
        platformOrderId: state.platformOrderId,
        price: rootState.donation.amount,
      };

      const STATUS_SUCCESS = 'Success';
      const STATUS_FAIL = 'Fail';

      try{
        const resp = await createJKOPayOrder(payload);
        if(resp.data.status == STATUS_SUCCESS) {
          const paymentUrl = resp.data.paymentUrl;
          return paymentUrl;
        } else if (resp.data.status == STATUS_FAIL) {
          const message = JKOPayResponseCodesTable[resp.data.resultCode];
          throw new Error(`創建失敗: ${message}`);
        }
      } catch(err) {
        throw new Error(err);
      }
    },
  },
};

